import { useMutation as y } from "@apollo/client";
import { accountSchema as C } from "../../deserialize/yup/account.js";
import B from "../../graphql/client/loginClient.js";
import { deserializeData as W } from "../../graphql/deserialize/index.js";
import h from "../../graphql/mutation/loginByWallet.js";
import S from "../account/useGetBindWalletInput.js";
import * as i from "ramda";
import { useState as b, useCallback as k } from "react";
const L = () => {
  const [t, { loading: n }] = y(h, {
    client: B
  }), { getBindWalletInput: e } = S(), [r, s] = b(null);
  return {
    mutate: k(
      async (l) => {
        const { type: m, inviter: a, walletAddress: c } = l, { message: p, signature: u, messageTimestamp: d, network: f, provider: g } = await e(m), v = i.isNil(a) ? {} : { invitationCode: i.pathOr("", ["invitation", "code"], a) }, w = await t({
          variables: {
            input: {
              address: c,
              isSmartContract: !1,
              // TODO: now isSmartContract is always false
              message: p,
              messageTimestamp: d,
              network: f,
              signature: u,
              walletProviderType: g,
              ...v
            }
          }
        }), o = W(w, C);
        return s(o), o;
      },
      [e, t]
    ),
    data: r,
    loading: n
  };
};
export {
  L as default
};
//# sourceMappingURL=useLoginByWallet.js.map
